export enum BADGE_TYPES {
  FIVE_INCH,
  ID_CARD,
  LARGE_ID,
  WRIST_BAND,
  FOLDABLE_A4,
  CUSTOM_BADGE
}

export enum BADGE_SIDES {
  FRONT_SIDE = 'front',
  BACK_SIDE = 'back'
}

export enum TOOLBAR_ACTIONS {
  SAVE,
  PUSH_UP,
  PUSH_DOWN,
  CONTENT_WIDTH_INCREASE,
  CONTENT_WIDTH_DECREASE,
  UNDO,
  REDO,
  START_OVER,
  SWITCH_SIDE
}

export enum DROP_AREAS {
  TOP = 'top-drop-area',
  BOTTOM = 'bottom-drop-area',
  LEFT = 'left-drop-area',
  RIGHT = 'right-drop-area',
  COL_TOP = 'col-top-drop-area',
  COL_BOTTOM = 'col-bottom-drop-area'
}
